class LocalizationDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this;
    this.closeBtn = this.querySelector('[data-localization-close]');
    this.tabs = this.querySelectorAll('[data-tab]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');
    this.searchInput = this.querySelector('[data-search-input]');
    this.countriesList = this.querySelector('[data-countries-list]');
    this.languagesList = this.querySelector('[data-languages-list]');
    this.countryItems = this.querySelectorAll('[data-country-item]');
    this.languageItems = this.querySelectorAll('[data-language-item]');
    
    this.currentTab = 'country';
    this.init();
  }

  init() {
    this.bindEvents();
    this.setupSearch();
  }

  bindEvents() {
    // Close drawer events
    this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
    
    // Tab switching
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.switchTab.bind(this));
    });

    // Country selection
    this.countryItems.forEach(item => {
      const radio = item.querySelector('input[type="radio"]');
      radio.addEventListener('change', this.handleCountryChange.bind(this));
    });

    // Language selection
    this.languageItems.forEach(item => {
      const radio = item.querySelector('input[type="radio"]');
      radio.addEventListener('change', this.handleLanguageChange.bind(this));
    });

    // Keyboard events
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  setupSearch() {
    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', this.handleSearch.bind(this));
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase();
    const items = this.currentTab === 'country' ? this.countryItems : this.languageItems;
    
    items.forEach(item => {
      const name = item.querySelector('.localization-drawer__item-label').textContent.toLowerCase();
      const isVisible = name.includes(searchTerm);
      item.style.display = isVisible ? 'block' : 'none';
    });
  }

  switchTab(event) {
    const targetTab = event.currentTarget.dataset.tab;
    
    // Update tab states
    this.tabs.forEach(tab => {
      tab.classList.remove('localization-drawer__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });
    
    event.currentTarget.classList.add('localization-drawer__tab--active');
    event.currentTarget.setAttribute('aria-selected', 'true');
    
    // Update tab content
    this.tabContents.forEach(content => {
      content.classList.remove('localization-drawer__tab-content--active');
    });
    
    const targetContent = this.querySelector(`[data-tab-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.add('localization-drawer__tab-content--active');
    }
    
    this.currentTab = targetTab;
    this.searchInput.placeholder = this.currentTab === 'country' 
      ? this.searchInput.dataset.placeholderCountry 
      : this.searchInput.dataset.placeholderLanguage;
    
    // Clear search when switching tabs
    if (this.searchInput) {
      this.searchInput.value = '';
      this.handleSearch({ target: this.searchInput });
    }
  }

  handleCountryChange(event) {
    const countryCode = event.target.value;
    const countryForm = document.getElementById('country-form');
    
    // Prevent loop by checking if we're already on the same country
    if (countryCode === countryForm.dataset.currentCountry) {
      return;
    }
    
    // Update the form input
    const countryInput = document.getElementById('form-country');
    countryInput.value = countryCode;
    
    // Set current country to prevent immediate re-submission
    countryForm.dataset.currentCountry = countryCode;
    
    // Submit the country form
    countryForm.submit();
  }

  handleLanguageChange(event) {
    const languageCode = event.target.value;
    const languageForm = document.getElementById('language-form');
    
    // Prevent loop by checking if we're already on the same language
    if (languageCode === languageForm.dataset.currentLanguage) {
      return;
    }
    
    // Update the form input
    const languageInput = document.getElementById('form-language');
    languageInput.value = languageCode;
    
    // Set current language to prevent immediate re-submission
    languageForm.dataset.currentLanguage = languageCode;
    
    // Submit the language form
    languageForm.submit();
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('localization-drawer--open')) {
      this.closeDrawer();
    }
  }

  openDrawer() {
    this.classList.add('localization-drawer--open');
    document.querySelector('site-overlay').classList.add('overlay-body');
    document.body.classList.add('scroll-fixed');
    Utility.trapFocus(this);
  }

  closeDrawer() {
    this.classList.remove('localization-drawer--open');
    document.querySelector('site-overlay').classList.remove('overlay-body');
    document.body.classList.remove('scroll-fixed');
    Utility.removeTrapFocus();
  }
}
customElements.define('localization-drawer', LocalizationDrawer);

/**
 * Localization Drawer Trigger
 */
document.addEventListener('DOMContentLoaded', function() {
  const localizationTrigger = document.querySelectorAll('[data-localization-trigger]');
  const localizationDrawer = document.querySelector('localization-drawer');
  
  if (localizationTrigger && localizationDrawer) {
    localizationTrigger.forEach(trigger => {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        localizationDrawer.openDrawer();
      });
    });
  }
});